import BarBase from './BarBase';

export default function InsuranceChart({ chartData }) {
  const data = [];
  const insCounts = {};

  for (const { insuranceProvider } of chartData) {
    if (!(insuranceProvider in insCounts)) {
      insCounts[insuranceProvider] = {
        label: insuranceProvider,
        value: 1,
      };
    } else {
      insCounts[insuranceProvider].value += 1;
    }
  }

  for (const ins of Object.values(insCounts)) {
    data.push(ins);
  }

  return (
    <BarBase
      title={'Insurance'}
      data={data}
      layout={'horizontal'}
    />
  );
}
